import React, {Component} from 'react';
import {
    Switch,
    Route
} from 'react-router-dom';
import {Container} from 'reactstrap';

import Header from '../../components/Header';
import Sidebar from '../../components/Sidebar';
import TYCookiesMsg from "../../components/TYCookiesMsg";

import Routes from "../../Utils/Routes";
import { observe, stopObserving } from '../../Utils/Observers';
import { USER_LOGGED_IN_EVENT, USER_LOGGED_OUT_EVENT } from '../../Utils/Events';
import { SetFCUser, ClearFCUser } from '../../Utils/Freshchat';


class Full extends Component {
    constructor(props){
        super(props);

        this.state = {
            loading: false,
            user: null
        };

        this.toggleLoading = this.toggleLoading.bind(this);
        this.pathname_to_title = this.pathname_to_title.bind(this);

        this.header = null;
    }

    componentDidMount(){
        observe(USER_LOGGED_IN_EVENT, this.setUser);
        observe(USER_LOGGED_OUT_EVENT, this.setUser);
    }

    componentWillUnmount(){
        stopObserving(USER_LOGGED_IN_EVENT, this.setUser);
        stopObserving(USER_LOGGED_OUT_EVENT, this.setUser);
    }

    setUser = user => {
        this.setState({user: user}, () => {
            if(user)
                SetFCUser(user);
            else
                ClearFCUser();
        });
    }

    toggleLoading(){
        this.setState({loading: !this.state.loading});
    }

    pathname_to_title(path){
        let title = "";

        if (path.length > 10 && path.substring(0, 10) === "/commande/")
            title = "Commande n° " + path.substring(10);
        else
            Routes.map(r => {
                if (typeof r.path !== "string"){
                    r.path.map(p => {
                        if (p === path)
                            title = r.name;
                    });
                }
                else {
                    if (r.path === path)
                        title = r.name;
                }
            });

        return title;
    }

    render() {
        return (
            <div className="app">

                {
                    this.state.loading ?
                        <div className="loading-overlay">
                            <i className="icon icon-loading animated spin infinite f-25" /><br /><br />
                            Chargement ...
                        </div>
                    :
                        null
                }

                <Header ref={ref => {this.header = ref}} current_path={this.props.location.pathname} title={this.pathname_to_title(this.props.location.pathname)}/>
                <div className="app-body">
                    <Sidebar toggleLoadingHandler={this.toggleLoading} {...this.props} onItemClicked={() => {this.header.onNavItemClicked()}}/>
                    <main className="main">
                        <Container fluid>
                            <Switch>
                                {
                                    Routes.map(r => {
                                        if (typeof r.path !== "string"){
                                            return r.path.map(p => {
                                                return <Route path={p} key={p} exact={r.exact || false} name={r.name} component={r.component} />
                                            });
                                        }
                                        else
                                            return <Route key={r.name} path={r.path} exact={r.exact || false} name={r.name} component={r.component} />;
                                    })
                                }
                            </Switch>
                        </Container>
                    </main>
                </div>
                

                <TYCookiesMsg />

            </div>
        );
    }
}

export default Full;



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js